import { openSupportEmail } from '@cart/ui/utils/contactSupport'

export const menuItemClickHandlers = {
  onContactUsClick: openSupportEmail,
}
